// src/theme-provider/foundations/shadows.ts
var shadows = {
  sm: "0px 1px 4px 0px rgba(0, 0, 0, 0.12)",
  md: "0px 1px 16px 0px rgba(0, 0, 0, 0.12)",
  lg: "0px 4px 24px 0px rgba(0, 0, 0, 0.16)"
};
var shadows_default = shadows;

export {
  shadows_default
};
